import {
  ClearPlusByOnDemandProvider,
  useClearPlusByOnDemand,
  CLEAR_PLUS_TABS,
} from './ClearPlusByOnDemandProvider';

export { useClearPlusByOnDemand, CLEAR_PLUS_TABS };
export default ClearPlusByOnDemandProvider;
